import { getCampaignList, getEmailCampaignDetailedReport, getEmailCampaignAnalytics } from "../types/account_campaign_types";

const initState = {
    list: {
        data: [],
        detailedData: [],
        count: 0,
        loading: false,
        error: false
    },
    analytics: {
        data: [],
        channel: "",
        loading: false,
    },
    detailedReport: {
        data: [],
        count: 0,
        channel: "",
        loading: false,
    },
};

export default function accountCampaignReducer(state = initState, action = {}) {
    switch (action.type) {
        case getCampaignList.GET_CAMPAIGN_LIST_REQUEST:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: true,
                }
            };
        case getCampaignList.GET_CAMPAIGN_LIST_REQUEST_AFTER: {
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false
                }
            };
        }
        case getCampaignList.GET_CAMPAIGN_LIST_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    data: action.payload.data,
                    detailedData: action.payload.detailedData,
                    count: action.payload.count,
                }
            };
        case getCampaignList.GET_CAMPAIGN_LIST_ERROR:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    error: action.payload
                }
            };
        case getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_REQUEST:
            return {
                ...state,
                detailedReport: {
                    ...state.detailedReport,
                    loading: true,
                },
            };
        case getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_SUCCESS:
            return {
                ...state,
                detailedReport: {
                    ...state.detailedReport,
                    loading: false,
                    data: action.payload.data,
                    channel: action.payload.channel,
                    count: action.payload.count,
                },
            };
        case getEmailCampaignDetailedReport.GET_EMAIL_CAMPAIGN_DETAILED_REPORT_ERROR:
            return {
                ...state,
                detailedReport: {
                    ...state.detailedReport,
                    loading: false,
                },
            };
        case getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_REQUEST:
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    loading: true,
                },
            };
        case getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_SUCCESS:
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    loading: false,
                    data: action.payload.data,
                    channel: action.payload.channel,
                },
            };
        case getEmailCampaignAnalytics.GET_EMAIL_CAMPAIGN_ANALYTICS_ERROR:
            return {
                ...state,
                analytics: {
                    ...state.analytics,
                    loading: false,
                },
            };
        default:
            return state;
    }
}
